// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"604":"6e5226b8","905":"7f90fca6"}[chunkId] + ".js";
};